import {
    CREATE_DYEING_INWARD_DETAILS_REQUEST,
    CREATE_DYEING_INWARD_DETAILS_SUCCESS,
    CREATE_DYEING_INWARD_DETAILS_FAILURE,
    DELETE_DYEING_INWARD_DETAILS_REQUEST,
    DELETE_DYEING_INWARD_DETAILS_SUCCESS,
    DELETE_DYEING_INWARD_DETAILS_FAILURE,
    FETCH_SINGLE_DYEING_INWARD_DETAILS_REQUEST,
    FETCH_SINGLE_DYEING_INWARD_DETAILS_SUCCESS,
    FETCH_SINGLE_DYEING_INWARD_DETAILS_FAILURE,
    FETCH_DYEING_INWARD_DETAILS_REQUEST,
    FETCH_DYEING_INWARD_DETAILS_SUCCESS,
    FETCH_DYEING_INWARD_DETAILS_FAILURE,
    UPDATE_DYEING_INWARD_DETAILS_REQUEST,
    UPDATE_DYEING_INWARD_DETAILS_SUCCESS,
    UPDATE_DYEING_INWARD_DETAILS_FAILURE,
    RESET_DYEING_INWARD_DETAILS_INFO,
    CREATE_DYEING_INWARD_DETAILS_FORM,
    UPDATE_DYEING_INWARD_DETAILS_FORM,
    FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_SUCCESS,
    FETCH_PREVIOUS_DYEING_INWARD_DETAILS_REQUEST,
    FETCH_PREVIOUS_DYEING_INWARD_DETAILS_SUCCESS,
    FETCH_PREVIOUS_DYEING_INWARD_DETAILS_FAILURE,
    FETCH_DYEING_INWARD_DETAILS_SO_AND_SN_REQUEST,
    FETCH_DYEING_INWARD_DETAILS_SO_AND_SN_SUCCESS,
    FETCH_DYEING_INWARD_DETAILS_SO_AND_SN_FAILURE,
    DYEING_INWARD_DETAILS_PO_DETAILS_DISABLED
} from './dyeingInwardDetails.actionsType';

export const DYEING_INWARD_DETAILS = 'dyeingInwardDetails';

let initialState = {
    loading: false,
    dyeingInwardDetails: [],
    dyeingInwardDetailsWithoutId: [],
    previousGetList: [],
    SOAndSNGetList: [],
    isPoDetailsDisabled: false,
    dyeingInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldReceivingRolls: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0,
        fldProcessLoss: 0,
        fldIsProcessLoss: false,
        fldFKPendingWeight:0
    },
    selectedState: {},
    errorMessage: ''
};

export let dyeingInwardDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_DYEING_INWARD_DETAILS_REQUEST:
        case FETCH_DYEING_INWARD_DETAILS_SO_AND_SN_REQUEST:
        case FETCH_PREVIOUS_DYEING_INWARD_DETAILS_REQUEST:
        case CREATE_DYEING_INWARD_DETAILS_REQUEST:
        case UPDATE_DYEING_INWARD_DETAILS_REQUEST:
        case FETCH_SINGLE_DYEING_INWARD_DETAILS_REQUEST:
        case DELETE_DYEING_INWARD_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_DYEING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingInwardDetails: updatePayload
            };
        case FETCH_DYEING_INWARD_DETAILS_SO_AND_SN_SUCCESS:
            return {
                ...state,
                loading: false,
                SOAndSNGetList: updatePayload
            };
        case FETCH_PREVIOUS_DYEING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload?.DYII
            };
        case FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingInwardDetailsWithoutId: updatePayload
            };
        case CREATE_DYEING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false
                },
                isPoDetailsDisabled: false
            };
        case UPDATE_DYEING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false
                },
                isPoDetailsDisabled: false
            };
        case FETCH_SINGLE_DYEING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingInwardDetailsForm: updatePayload
            };
        case DELETE_DYEING_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false
                },
                isPoDetailsDisabled: false
            };
        case DYEING_INWARD_DETAILS_PO_DETAILS_DISABLED:
            return {
                ...state,
                isPoDetailsDisabled: payload
            };
        case RESET_DYEING_INWARD_DETAILS_INFO:
            return {
                ...state,
                dyeingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false
                },
                isPoDetailsDisabled: false
            };
        case CREATE_DYEING_INWARD_DETAILS_FORM:
        case UPDATE_DYEING_INWARD_DETAILS_FORM:
            return {
                ...state,
                loading: false,
                dyeingInwardDetailsForm: {
                    ...state.dyeingInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_DYEING_INWARD_DETAILS_FAILURE:
        case FETCH_DYEING_INWARD_DETAILS_SO_AND_SN_FAILURE:
        case FETCH_PREVIOUS_DYEING_INWARD_DETAILS_FAILURE:
        case CREATE_DYEING_INWARD_DETAILS_FAILURE:
        case UPDATE_DYEING_INWARD_DETAILS_FAILURE:
        case FETCH_SINGLE_DYEING_INWARD_DETAILS_FAILURE:
        case DELETE_DYEING_INWARD_DETAILS_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
